import { ImageIcon } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { MediaLibrary } from "./MediaLibrary";

export function MediaLibraryPage() {
  return (
    <div>
      <PageHeader
        icon={ImageIcon}
        title="Media Library"
        description="Store, organise and reuse images, videos, and documents across your posts and press kits. All media is shared across your team."
      />
      <MediaLibrary />
    </div>
  );
}
